/**
 * Router Constants
 * Centralized route paths for the application
 * Similar to Routes object in ward-desktop
 */

export const Routes = {
  // Auth routes
  Login: '/login',

  // Business/Pages routes
  Business: '/business',

  // Student routes
  StudentHome: '/student-home',
  Agenda: '/agenda',
  Notes: '/notes',
  Absences: '/absences',
  AroundTheWorld: '/around-the-world',

  // Professional routes
  StageAlternanceDashboard: '/stage-alternance-dashboard',

  // Employee routes
  EmployeeHome: '/employee-home',

  // Common routes
  Profile: '/profile',
  Search: '/search',
  Shop: '/shop',
  Suggestion: '/suggestion',
  PartnerUniversities: '/partner-universities',

  // Other
  Home: '/',
} as const;

/**
 * Route mapping for internal URL detection
 * Maps URL keywords to internal routes
 * Used by NavigationService to detect if a URL should be handled internally
 */
export const INTERNAL_ROUTE_MAP: Record<string, string> = {
  partenaires: Routes.PartnerUniversities,
  absences: Routes.Absences,
  agenda: Routes.Agenda,
  notes: Routes.Notes,
  suggestion: Routes.Suggestion,
  'around-the-world': Routes.AroundTheWorld,
  shop: Routes.Shop,
  'stage-alternance-dashboard': Routes.StageAlternanceDashboard,
  stage: Routes.StageAlternanceDashboard, // Special case
};

/**
 * Check if a URL contains keywords that indicate an internal route
 */
export function detectInternalRoute(url: string): string | null {
  for (const [keyword, route] of Object.entries(INTERNAL_ROUTE_MAP)) {
    if (url.includes(keyword)) {
      return route;
    }
  }
  return null;
}
